import MarqueeLib from 'react-fast-marquee';
import { useGetNotificationsQuery } from '@/store/api/contentApi';

const Marquee = ({ type }: { type?: string }) => {
  const { data } = useGetNotificationsQuery({ type: 'Alert' });

  const alerts = data?.data?.Alert?.filter((item) => item.isActive).map((item) => item.body) || [];
  if (!alerts.length) return null;

  const content = (
    <MarqueeLib speed={60} gradient={false} pauseOnHover={false}>
            
      {alerts.map((text, index) => (
        <span key={index} className="mr-6 flex items-center">
                    {text}
                    {index !== alerts.length - 1 && <span className="mx-3">|</span>}
                  
        </span>
      ))}
          
    </MarqueeLib>
  );

  if (type === 'mobile') {
    return (
      <div className="whitespace-nowrap overflow-hidden py-[3px] flex-1 text-body-inverse text-sm italic bg-body-muted">
                {content}
              
      </div>
    );
  }

  return (
    <div
      style={{ lineHeight: 'normal' }}
      className="max-xl:hidden italic text-sm overflow-hidden whitespace-nowrap w-1/2 text-white"
    >
            {content}
          
    </div>
  );
};

export default Marquee;
